module.exports = __webpack_public_path__ + "fonts/KaTeX_AMS-Regular.d562e88.woff";